import { from, of } from "rxjs";
import { catchError } from "rxjs/operators";

const swallowApiErrors = (fn, fallback) => {
  return from(fn()).pipe(
    catchError(e => {
      return of(fallback);
    })
  );
};

export { swallowApiErrors };
